import { gql } from "@apollo/client";

export const activitiesQuery = gql`
    query ActivitiesAdmin($cameraId: ID!, $page: Int, $size: Int, $sort: SortInput) {
        activitiesAdmin(cameraId: $cameraId, page: $page, size: $size, sort: $sort) {
            nodes {
                id
                message
                createdBy
                createdAt
            }
            totalCount
            totalPages
            nextPage
            previousPage
        }
    }
`;

export const createActivityMutation = gql`
    mutation CreateActivityAdmin($input: CreateActivityInput!) {
        createActivity(input: $input) {
            id
        }
    }
`;

export const updateActivityMutation = gql`
    mutation UpdateActivityAdmin($id: ID!, $input: UpdateActivityInput!) {
        updateActivity(id: $id, input: $input) {
            message
            createdBy
        }
    }
`;

export const deleteActivityMutation = gql`
    mutation DeleteActivityAdmin($id: ID!) {
        removeActivity(id: $id)
    }
`;

export const activityQuery = gql`
    query ActivityAdmin($id: ID!) {
        activityAdmin(id: $id) {
            id
            createdBy
            message
            createdAt
        }
    }
`;
